import exportToExcel from '@/utils/excelExport';

const sanitizeText = text => {
  let _text = text;

  if (_text) {
    _text = text
      .replace(/\u00A0/g, '')
      .replace('<[^>]*>', '')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&hellip;/g, '...')
      .replace(/&sect;/g, '§')
      .replace(/&bull;/g, '•')
      .replace(/<(?:br|\/div|\/p)>/g, '\n')
      .replace(/<.*?>/g, '')
      .replace(/&ndash;|&mdash;/g, '-')
      .replace(/&rsquo;|&lsquo;/g, "'")
      .replace(/&rdquo;|&ldquo;/g, '"')
      .replace(/&nbsp;/g, ' ');
  }

  return _text;
};
const getValue = (record, camelKey, pascalKey) => {
  return record?.[camelKey] ?? record?.[pascalKey];
};

export default async ({
  data,
  sheetTitle = 'APCIA Export',
  fileName = 'sheet.xlsx',
  displayChanges = false,
}) => {
  const exportData = data.map(d => {
    const chartTitle = getValue(d, 'chartTitle', 'ChartTitle');
    const chartState = getValue(d, 'chartState', 'ChartState');
    const chartTopic = getValue(d, 'chartTopic', 'ChartTopic');
    const details = getValue(d, 'details', 'Details');
    const recentChanges = getValue(d, 'recentChanges', 'RecentChanges');
    const stateNotes = getValue(d, 'stateNotes', 'StateNotes');

    if (displayChanges) {
      return [chartTitle, chartState, chartTopic, sanitizeText(recentChanges || details)];
    }

    return [
      chartTitle,
      chartState,
      chartTopic,
      sanitizeText(details),
      sanitizeText(recentChanges),
      sanitizeText(stateNotes),
    ];
  });

  const columns = displayChanges
    ? ['Chart', 'State', 'Topic', 'Most Recent Changes']
    : ['Chart', 'State', 'Topic', 'Details', 'Most Recent Changes', 'State Notes'];

  exportToExcel(columns, exportData, sheetTitle, fileName);
};
